/** Brand preloader — bird mark fill + dismiss timing. */

export const PRELOADER_LOGO_SRC = '/svg/birdlife-logo-mark-white.svg' as const;

/** Bird mark viewBox aspect (83.25 × 36.44). */
export const PRELOADER_LOGO_ASPECT_RATIO = '83.25 / 36.44' as const;

/** Max crawl progress before boot-ready completes the fill. */
export const PRELOADER_PROGRESS_CAP = 0.95;

/**
 * Time (ms) for the indeterminate crawl toward the progress cap.
 * Mirrored in `Preloader.module.css` (`preloader-crawl` duration) so the
 * fill starts on first paint without waiting for JS hydration.
 */
export const PRELOADER_CRAWL_DURATION_MS = 4000;

/** Quick ease from crawl cap → 100% once boot is ready. */
export const PRELOADER_COMPLETE_DURATION_MS = 160;

/** Above Navbar (100) / Overlay (100) / CookieBanner (1000) while visible. */
export const PRELOADER_Z_INDEX = 2000;
